import constants from 'constants/index'

const { BYTE_UNIT_EXPONENT } = constants.validations

const size = (bytes = 0) => {
  const units = ['bytes', 'kB', 'MB', 'GB']
  let index = 0
  let size = bytes

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024
    index++
  }

  const formattedSize = size?.toFixed(1)
  return `${formattedSize} ${units[index]}`
}

const toBytes = (value, unit = 'MB') => {
  return value * BYTE_UNIT_EXPONENT[unit]
}

const allowedTypes = (types) => {
  return types.replace(/\./g, '').replace(/,/g, ', ').toUpperCase()
}

export default {
  size,
  toBytes,
  allowedTypes,
}
